/** Static data tables: processor prefixes, canonical merchants, category rules. */

/** Payment-processor prefixes that hide the real merchant. */
export const PREFIXES: RegExp[] = [
  /^paypal\s*\*/i, /^pp\s*\*/i, /^sq\s*\*/i, /^square\s*\*/i, /^tst\s*\*/i,
  /^sp\s+/i, /^google\s*\*/i, /^apl\s*\*/i, /^gpay\s*\*/i, /^amzn\s+mktp/i,
  /^pos\s+(debit|purchase)\s*/i,
  /^(debit|ach|recurring|card)\s+(card\s+)?(purchase|payment|pmt|withdrawal)\s*/i,
  /^checkcard\s+/i, /^visa\s+/i,
  /^purchase\s+authorized\s+on\s+\d{1,2}\/\d{1,2}\s*/i,
];

export const CANONICAL: [RegExp, string][] = [
  [/apple\.com\/bill|itunes|apple\s+services/i, 'Apple Services'],
  [/amazon\s*prime|amzn\s*prime/i, 'Amazon Prime'],
  [/audible/i, 'Audible'],
  [/netflix/i, 'Netflix'],
  [/spotify/i, 'Spotify'],
  [/hulu/i, 'Hulu'],
  [/disney\s*(\+|plus)/i, 'Disney+'],
  [/hbo|max\.com/i, 'Max'],
  [/youtube\s*(premium|tv)?/i, 'YouTube Premium'],
  [/icloud/i, 'iCloud'],
  [/google\s*(one|storage)/i, 'Google One'],
  [/dropbox/i, 'Dropbox'],
  [/adobe/i, 'Adobe'],
  [/microsoft|msft|office\s*365/i, 'Microsoft 365'],
  [/openai|chatgpt/i, 'OpenAI'],
  [/anthropic|claude/i, 'Claude'],
  [/github/i, 'GitHub'],
  [/nytimes|ny\s*times|new\s*york\s*times/i, 'New York Times'],
  [/wall\s*st|wsj/i, 'Wall Street Journal'],
  [/planet\s*fitness/i, 'Planet Fitness'],
  [/peloton/i, 'Peloton'],
  [/strava/i, 'Strava'],
  [/duolingo/i, 'Duolingo'],
  [/notion/i, 'Notion'],
  [/slack/i, 'Slack'],
  [/zoom\.us|zoom\s*video/i, 'Zoom'],
  [/linkedin/i, 'LinkedIn'],
  [/patreon/i, 'Patreon'],
  [/twitch/i, 'Twitch'],
  [/paramount/i, 'Paramount+'],
  [/crunchyroll/i, 'Crunchyroll'],
  [/comcast|xfinity/i, 'Xfinity'],
];

export const CATEGORIES: [RegExp, string][] = [
  [/netflix|hulu|disney|hbo|max$|paramount|peacock|crunchyroll|youtube tv|apple tv/i, 'Streaming'],
  [/spotify|apple music|tidal|pandora|youtube premium|audible|deezer/i, 'Music & Audio'],
  [/icloud|dropbox|google one|onedrive|backblaze|box\.com/i, 'Cloud Storage'],
  [/adobe|microsoft|notion|slack|zoom|github|figma|canva|openai|claude|chatgpt|linkedin|1password|grammarly|apple\.com\/bill|apple services/i, 'Software & Tools'],
  [/gym|fitness|peloton|strava|yoga|crossfit|equinox|orangetheory/i, 'Health & Fitness'],
  [/times|journal|post$|news|economist|atlantic|medium|substack|wired/i, 'News & Reading'],
  [/duolingo|coursera|udemy|skillshare|masterclass|brilliant/i, 'Education'],
  [/prime|walmart\+|instacart|doordash|dashpass|uber one|costco/i, 'Shopping & Delivery'],
  [/insurance|geico|allstate|progressive/i, 'Insurance'],
  [/verizon|t-?mobile|at&t|comcast|xfinity|spectrum|internet|wireless/i, 'Utilities & Telecom'],
  [/patreon|twitch|onlyfans|ko-?fi/i, 'Creators & Donations'],
];

/** Categories where multiple simultaneous subscriptions usually mean overlap. */
export const OVERLAP_CATEGORIES = ['Streaming', 'Music & Audio', 'Cloud Storage'];
